import { render, staticRenderFns } from "./PartialDocumentsList.vue?vue&type=template&id=b8045840"
import script from "./PartialDocumentsList.vue?vue&type=script&lang=js"
export * from "./PartialDocumentsList.vue?vue&type=script&lang=js"
import style0 from "./PartialDocumentsList.vue?vue&type=style&index=0&id=b8045840&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports